import { frontendURL } from '../../../helper/URLHelper';
import PlansIndex from './pages/PlansIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/planos'),
    alias: [
      frontendURL('accounts/:accountId/plans'),
      frontendURL('accounts/:accountId/plano'),
    ],
    name: 'planos_index',
    component: PlansIndex,
    meta: { permissions: ['administrator'] },
  },
];
